export default __webpack_public_path__ + "static/media/6.2c32f9d6.webp";